import * as Yup from 'yup';

export const fixedFieldsSchema = Yup.object().shape({
  conservationCondition: Yup.string(),
  productEnrichment: Yup.string(),
  finishedProductDescription: Yup.string(),
});